function scale(name, scale) {
  if(!arguments.length) return this.__execs__.scale;
  else {
    if(!scale) return this.__execs__.scale[name];
    else return this.__setting.scale[name] = scale;
    //TODO: 이름 분리해서 해당 scale 가져가기 (orient.field)
  }
}

export default scale;


// WEBPACK FOOTER //
// ../node_modules/daisy-chart/src/layouts/default/scale.js